export const SET_CALL_DIRECTION = 'SET_CALL_DIRECTION';
export const SET_PHONE_FIELD_VALUE = 'SET_PHONE_FIELD_VALUE';
export const SET_SUBSCRIBER = 'SET_SUBSCRIBER';
export const SET_IS_CONTROL_PANEL_VISIBLE = 'SET_IS_CONTROL_PANEL_VISIBLE';
export const SET_NUM_PAD_VISIBLE = 'SET_NUM_PAD_VISIBLE';
export const SET_PHONE_FIELD_POS = 'SET_PHONE_FIELD_POS';
export const SET_SILENT_MODE = 'SET_SILENT_MODE';
export const SET_RINGTONE_PLAY_ERROR = 'SET_RINGTONE_PLAY_ERROR';
export const SET_RINGTONE_DEVICES_DATA = 'SET_RINGTONE_DEVICES_DATA';
export const SET_SELECTED_RINGTONE_DEVICE = 'SET_SELECTED_RINGTONE_DEVICE';
export const SET_USER_MEDIA_ERROR = 'SET_USER_MEDIA_ERROR';
export const SET_SERVICE_COMPANY = 'SET_SERVICE_COMPANY ';
export const SET_COMPANY_VISIBLE = 'SET_COMPANY_VISIBLE';
